import React from 'react';
import { Grid, Column, Breadcrumb, BreadcrumbItem } from '@carbon/react';
import { ConsentManagementInterface } from '../../components/privacy/ConsentManagementInterface';
import { AuthGuard } from '../../components/auth/AuthGuard';
import { Link } from 'react-router-dom';

export const ConsentPage: React.FC = () => {
  // Temporarily bypass auth for staging testing
  const isStaging = typeof window !== 'undefined' && window.location.hostname === 'staging.sigma08.com';

  const content = (
    <>
      <Grid fullWidth>
        <Column lg={16} md={8} sm={4}>
          <Breadcrumb>
            <BreadcrumbItem>
              <Link to="/">Home</Link>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <Link to="/privacy">Privacy</Link>
            </BreadcrumbItem>
            <BreadcrumbItem isCurrentPage>Consent Management</BreadcrumbItem>
          </Breadcrumb>
        </Column>
      </Grid>
      <ConsentManagementInterface />
    </>
  );

  // Skip auth guard in staging for testing
  if (isStaging) {
    return content;
  }

  return <AuthGuard requiredRole="user">{content}</AuthGuard>;
};
